import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const getAllPartialRejectedTest = (object: any) => {
  return HttpClient().post(`/${apiRoutes.PartialRejectedTest.GetAll}`, object);
};

export const GetPartialRejectedOrdersById = (object: any) => {
  return HttpClient().post(
    `/${apiRoutes.PartialRejectedTest.GetPartialRejectedOrdersById}`,
    object
  );
};
